module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("The Theater of God’s Glory: Calvin, Creation, and the Liturgical Arts")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "../styles/stylesheet.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#chapter001"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 1")])])]), _vm._v(" "), _c('p', {
    staticClass: "CT"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#chapter001"
    }
  }, [_vm._v("Musical Instruments in Calvin")])]), _vm._v(" "), _c('p', {
    staticClass: "CE"
  }, [_c('i', [_vm._v("[Calvin’s] exemplary liturgy will be simplex, pura and spiritualis, “plain,” “unadorned” and “spiritual.”")])]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_vm._v("Peter Auksi, “Simplicity and Silence”")]), _vm._v(" "), _c('p', {
    staticClass: "CE"
  }, [_c('i', [_vm._v("I have no doubt that playing upon cymbals, touching the harp and the viol, and all that kind of music, which is so frequently mentioned in the Psalms, was a part of the education; that is to say, the puerile instruction of the law.")])]), _vm._v(" "), _c('p', {
    staticClass: "CC"
  }, [_vm._v("Calvin, "), _c('i', [_vm._v("Comm.")]), _vm._v(" Psalms")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("Calvin’s appreciation for both music and the psalms is well known by those who count themselves his liturgical heirs. In his "), _c('i', [_vm._v("Epistle to the Reader")]), _vm._v(", his foreword to the very popular Genevan Psalter, he writes: “Now among the other things which are appropriate for recreating people and giving them pleasure, music is either the first or one of the principal, and we must value it as a gift of God deputed to that use.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("The singing of psalms, Calvin remarks in 1537, “can incite us to lift up our hearts to God and move us to an ardor in invoking and exalting with praises the glory of his Name.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn2",
      "id": "fn2"
    }
  }, [_vm._v("2")])]), _vm._v(" It is estimated that, on average, Genevan "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("Christians would have sung at any given service between sixteen and thirty psalm stanzas, which, according to Paul Jones, amounts to “the equivalent of five hymns of up to 6 stanzas each.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn3",
      "id": "fn3"
    }
  }, [_vm._v("3")]), _vm._v(" In the tradition that followed Calvin, the singing of metrical psalms would become one of the singular distinguishing features of Calvinists of the sixteenth and seventeenth centuries."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn4",
      "id": "fn4"
    }
  }, [_vm._v("4")])]), _vm._v(" How Calvin viewed musical instruments, however, is a mixed bag. While he envisions a legitimate place for their use “at home” and “in the fields,” he does not regard them as appropriate to corporate worship. Typical of his thinking is this observation: “For even now, if believers choose to cheer themselves with musical instruments, they should, I think, make it their object not to dissever their cheerfulness from the praises of God. But when they frequent their sacred assemblies, musical instruments in celebrating the praises of God would be no more suitable than the burning of incense, the lighting up of lamps, and the restoration of the other shadows of the law.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn5",
      "id": "fn5"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("If scholars take notice of Calvin’s ideas about instruments, it will be to observe that he locates them under the era of “figures and shadows.” More often, the matter is left altogether untreated. In the case of Charles Garside’s seminal essay “The Origins of Calvin’s Theology of Music: 1536–1543,” for example, the focus remains exclusively on music as a general topic."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn6",
      "id": "fn6"
    }
  }, [_vm._v("6")])]), _vm._v(" H. P. Clive’s treatment does more than most, for he rightly situates Calvin’s concerns about instruments within a wider historical context and thus brings to light the kind of historical “pressures” that may account for the Reformer’s conclusions in a way that exegetical or theological scrutiny alone cannot."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn7",
      "id": "fn7"
    }
  }, [_vm._v("7")])]), _vm._v(" The aim of this chapter is to press the topic in a more thoroughgoing manner and to suggest that Calvin’s thinking on musical instruments in public worship is far more complicated and interesting than commentators have often allowed.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Song and Instruments")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "H2"
  }, [_vm._v("Calvin and Congregational Song")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In order to put Calvin’s ideas about musical instruments in context, it will be helpful to summarize his view of congregational song:")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("Singing obtains not only a possible place in the liturgy but a positive place, for it intensifies our capacity to worship God.")]), _vm._v(" "), _c('li', [_vm._v("Not just any singing will do. We must sing rightly, which involves a consideration for both the mind and the heart, for both understanding and affection.")]), _vm._v(" "), _c('li', [_vm._v("The kind of singing that pleases God most is the kind that is done commonly (i.e., in unison), as if with “the same mouth.”")]), _vm._v(" "), _c('li', [_vm._v("Because our worship must accord with God’s holy Word, God has provided us with good, fitting words—namely, the psalms of David; when these are sung well, they lead to maximal edification and to right moral formation.")]), _vm._v(" "), _c('li', [_vm._v("Because not any melody will do for corporate worship but only that which befits congregational song, God has provided us with skilled musicians to compose melodies suitable to corporate worship.")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Whereas the 1559 "), _c('i', [_vm._v("Institutes")]), _vm._v(", the “Articles” (1537), and the "), _c('i', [_vm._v("Epistle to the Reader")]), _vm._v(" omit mention of musical instruments, Calvin directly addresses their use in his commentaries on the Psalms. The context he presumes in these commentaries is public worship, while the aim is, as always, “pure worship.” Calvin makes two kinds of statements about musical instruments: positive and negative. I take each in turn.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Positive Comments on Musical Instruments")])]), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Positively, musical instruments perform a double benefit for Israel’s worship. On the one hand, they incite the heart to exuberant praise: they "), _c('i', [_vm._v("express")]), _vm._v(" ardent affection for God,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn8",
      "id": "fn8"
    }
  }, [_vm._v("8")]), _vm._v(" they "), _c('i', [_vm._v("stimulate")]), _vm._v(" increased devotion to God, stirring the worshiper “up more actively to the celebration "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("of the praise of God with the heart,”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn9",
      "id": "fn9"
    }
  }, [_vm._v("9")]), _vm._v(" and they "), _c('i', [_vm._v("indicate")]), _vm._v(" that even the “most ardent attempts” to celebrate God’s mighty deeds will fall “short of the riches of the grace of God.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn10",
      "id": "fn10"
    }
  }, [_vm._v("10")])]), _vm._v(" In his comments on Psalm 150, Calvin regards the enumeration of instruments as a kind of metaphor for corporate singing. Even as the sound of one instrument piles on top of that of another, producing an exuberant sound, so our individual praise piled on top of the praises of others, producing a kind of exuberant praise, cannot capture the full measure of adoration that God deserves. For the Jews, however, instruments attained that kind of vibrant adoration.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("On the other hand, musical instruments serve as deterrents to an “unruly flesh” and therefore performed a crucial moral function in Jewish life. They protect the worshiper not only from a “cold faith” but also from the possibility of sliding into error."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn11",
      "id": "fn11"
    }
  }, [_vm._v("11")])]), _vm._v(" God commands a multiplicity of songs, Calvin explains in his commentary on Psalm 150:3, in order that “he might lead men away from those vain and corrupt pleasures to which they are excessively addicted, to a holy and profitable joy. Our corrupt nature indulges in extraordinary liberties, many devising methods of gratification which are preposterous, while their highest satisfaction lies in suppressing all thoughts of God. This perverse disposition could only be corrected in the way of God’s retaining a weak and ignorant people under many restraints, and constant exercises.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn12",
      "id": "fn12"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Negative Comments on Musical Instruments")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("On the negative side, Calvin’s argument against instruments in a new-covenantal liturgy involves four contentions. First, he stresses that instruments belong to "), _c('i', [_vm._v("the era of figures and shadows")]), _vm._v(". For Calvin, instruments represent the “infancy of the Church,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn13",
      "id": "fn13"
    }
  }, [_vm._v("13")])]), _vm._v(" forming a “part of the training "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("of the Law”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn14",
      "id": "fn14"
    }
  }, [_vm._v("14")]), _vm._v(" “under the legal economy,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn15",
      "id": "fn15"
    }
  }, [_vm._v("15")])]), _vm._v(" and correspond to the “dispensation of shadows and figures,” which characterized Jewish believers. When the Israelites used harp and lyre, it was done because of the “generally prevailing custom of that time.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn16",
      "id": "fn16"
    }
  }, [_vm._v("16")])]), _vm._v(" Christians are not to insist on their continuation, for to do so is to perpetuate “the ceremonies of the law.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn17",
      "id": "fn17"
    }
  }, [_vm._v("17")])]), _vm._v(" God commanded timbrels and trumpets to “train his people, while they were as yet tender and like children, by such rudiments, until the coming of Christ”;"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn18",
      "id": "fn18"
    }
  }, [_vm._v("18")])]), _vm._v(" the Jews, “who were yet under age,” required the use of “such childish elements.” In one sense, Calvin says, instruments were not in themselves necessary; they were only “useful” as elementary aids to the people of God. Now that the church has “reached full age,” instruments can be set aside."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn19",
      "id": "fn19"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Second, Calvin insists that the reintroduction of instruments into public worship leads people to cling to “earthly” things when God has expressly commanded that they worship him in "), _c('i', [_vm._v("spiritual")]), _vm._v(" fashion."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn20",
      "id": "fn20"
    }
  }, [_vm._v("20")])]), _vm._v(" He comments: “We are to remember that the worship of God was never understood to consist in such outward services, which were only necessary to help forward a people, as yet weak and rude in knowledge, in the spiritual worship of God.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn21",
      "id": "fn21"
    }
  }, [_vm._v("21")])]), _vm._v(" He elaborates on this point in a sermon on 2 Samuel, arguing that to reinsert such external elements “would be nothing but a silly performance now, which would obscure the spiritual worship spoken of in the fourth chapter of St. John. For there our Lord Jesus Christ declares to us how we must no longer govern ourselves by the Law.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn22",
      "id": "fn22"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In this light, musical instruments risk contaminating the true praise of God. As Selderhuis observes, Calvin “fears that, by using musical instruments, the correct balance would be disturbed between the joy caused by music and the joy due to the praise of God.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn23",
      "id": "fn23"
    }
  }, [_vm._v("23")])]), _vm._v(" Calvin asks: “Does anyone object, that music is very useful for awakening the minds "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("of men and moving their hearts? I own it; but we should always take care that no corruption creep in, which might both defile the pure worship of God and involve men in superstition.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn24",
      "id": "fn24"
    }
  }, [_vm._v("24")]), _vm._v(" The use of instruments in public prayers, in short, defiles such worship.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Third, Calvin insists that God is more pleased with "), _c('i', [_vm._v("simple")]), _vm._v(" worship. This idea functions as a kind of corollary to the first, where the opposite of “shadowy” worship is “simple” worship. Likewise, the opposite of a ceremonially and materially extravagant worship is a ceremonially and materially simple worship. Papists “ape” Israel in their employment of instruments. They do so, Calvin maintains, in “a senseless and absurd manner,” “exhibiting a silly delight in that worship of the Old Testament which was figurative, and terminated with the Gospel.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn25",
      "id": "fn25"
    }
  }, [_vm._v("25")])]), _vm._v(" Fond of “outward pomp,” Rome persists in a “wicked and perverse obstinacy,” causing Christians to stumble into superstitious activities."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn26",
      "id": "fn26"
    }
  }, [_vm._v("26")])]), _vm._v(" In contrast, simple worship occurs under “the clear light of the gospel,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn27",
      "id": "fn27"
    }
  }, [_vm._v("27")])]), _vm._v(" which has dissipated the shadows of the law. To the extent that musical instruments represented a form of “outward service,” they were necessary for a people who are weak, ignorant, and frail."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn28",
      "id": "fn28"
    }
  }, [_vm._v("28")])]), _vm._v(" Because Christ has now appeared, however, for the church to persist in the use of musical instruments is “to bury the light of the Gospel” and to “introduce the shadows of a departed dispensation.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn29",
      "id": "fn29"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Finally, instruments fail St. Paul’s requirement that praise be offered in an "), _c('i', [_vm._v("articulate")]), _vm._v(" voice. This contention appears as a new line of argument. While “simple” worship operates as an obverse to an externally “thick” worship, the idea of “articulate” worship functions as an ancillary argument to the above contentions, while also remaining central to Calvin’s presuppositions about public worship. As Calvin forthrightly states: “The name of God, no doubt, can, properly speaking, be celebrated only by the articulate voice.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn30",
      "id": "fn30"
    }
  }, [_vm._v("30")])]), _vm._v(" More strongly even, Calvin argues that instruments "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("“are banished out of the churches by the plain command of the Holy Spirit.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn31",
      "id": "fn31"
    }
  }, [_vm._v("31")]), _vm._v(" For this judgment Calvin appeals to 1 Corinthians 14:13–16. From this New Testament passage, Calvin infers that instruments can generate only an inarticulate voice and ipso facto cannot meet the standards of right worship. Curiously, Calvin excludes chanting on similar grounds because it “fills the ears with nothing but an empty sound.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn32",
      "id": "fn32"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Questions")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("A few questions arise at this point. How exactly did instruments “train” the Israelites? If they intensified the affections and enlarged the praise of God,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn33",
      "id": "fn33"
    }
  }, [_vm._v("33")])]), _vm._v(" do Christians no longer require such training? Did Calvin place musical instruments under the era of “figures and shadows” because of their ceremonial function or because of their status as physical media?"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn34",
      "id": "fn34"
    }
  }, [_vm._v("34")])]), _vm._v(" Calvin argues that instruments, by virtue of their resemblance to an “inarticulate” voice, cannot properly praise God. If that is the case, what do we make of the worship that Israel offered God with pipes and cymbals? Is St. Paul’s command in 1 Corinthians 14 an arbitrary command—that while God was once pleased to command and receive both articulate (vocal) and inarticulate (instrumental) worship, God no longer deems such worship pleasing? If answers are to be found to these questions, they will be discovered, first, by following Calvin into his reading of John 4 and 1 Corinthians 14.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Instruments and the New Testament")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("John 4")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Calvin summarizes the exchange between Jesus and the Samaritan woman in John 4:23–24 by noting that their conversation concerns the nature of “the pure worship of God.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn35",
      "id": "fn35"
    }
  }, [_vm._v("35")])]), _vm._v(" Pertinent to our concerns, Calvin notes that, with the coming of Christ, the era of ceremonies has come to an end. Now, "), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("nothing “is hidden or obscure.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn36",
      "id": "fn36"
    }
  }, [_vm._v("36")]), _vm._v(" The substance of the gospel brings to light what Jews, with their use of incense, candles, holy garments, altar, and vessels, could know only in “shadow” form. Rome’s burden is precisely the “foolish affectation of copying Jewish ceremonies.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn37",
      "id": "fn37"
    }
  }, [_vm._v("37")])]), _vm._v(" Such practices obscure Christ again. What does it mean, then, to worship “in the spirit”? It means, in this context, to worship spiritually, which is another way of saying that God must be worshiped inwardly. “The worship of God is said to consist in the spirit, because it is nothing else than that inward faith of the heart which produces prayer, and, next, purity of conscience and self-denial, that we may be dedicated to obedience to God as holy sacrifices.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn38",
      "id": "fn38"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("To stress the chiefly inward character of pure worship, Calvin describes it as “faith, prayer, thanksgiving, purity of heart, and innocence of life”; and to reinforce the point, he adds that “at no time did [God] delight in any other sacrifices.” Conversely, nonspiritual worship corresponds to outward or external worship, which is the kind of worship that the Jewish people had grown accustomed to but that Christ had now abolished. Does this mean that Jewish worship was devoid of spiritual content? No, to the contrary, says Calvin. Such worship as God had commanded the Jewish people was in fact spiritual, only it was concealed under figures and shadows—“it was enveloped in so many outward ceremonies that it resembled something carnal and earthly.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn39",
      "id": "fn39"
    }
  }, [_vm._v("39")])]), _vm._v(" Calvin cites Paul’s statement in Galatians 4:9 as warrant for this conclusion. There Paul describes ceremonial practices, such as the observance of “days and seasons,” as “weak and worthless elemental things.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn40",
      "id": "fn40"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Is there a place, then, for “outward exercises of godliness”? Calvin concedes that Christians will indeed need these, but he insists that they be few, moderate, and sober and that they not “obscure the plain truth of Christ.” With such “plain and simple worship” God is well pleased. The “simple” truth of Christ, then, must express itself in a “simple” liturgy. Anything more, Calvin insists, will “deprive the Church of the presence of Christ.” While the “spirit” was indeed concealed by the shadows of the law, the masks of popery “disfigure” it altogether. “Therefore we must on no account connive at such horrible and unworthy corruptions.” Why do we need such outward exercises? Calvin answers: “our weakness renders” "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("them necessary. What constitutes worship “in spirit and truth”? Answer: “It is to remove the coverings of the ancient ceremonies and retain simply what is spiritual in the worship of God. For the truth of the worship of God rests in the spirit, and ceremonies are so to say adventitious.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn41",
      "id": "fn41"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("For Calvin, the phrase “spirit and truth” functions as a hendiadys. Rather than referring to two distinct realities, they describe a common one, namely, that worship with the coming of Christ designates chiefly an inward reality."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn42",
      "id": "fn42"
    }
  }, [_vm._v("42")])]), _vm._v(" While “spirit” can be seen to describe for Calvin the interior domain of worship, whether as faith or prayer, “truth” seems to refer to their “substance.” “Truth” is not contrasted with falsehood but rather with “the outward addition of the figures of the Law.” To restate his point, Calvin notes that the kind of worship that the Father seeks “is the pure and simple substance of spiritual worship.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn43",
      "id": "fn43"
    }
  }, [_vm._v("43")])]), _vm._v(" Finally, what does Jesus mean when he says that “God is Spirit”? Calvin answers that this sentence describes the essential nature of God. Against certain patristic theologians, who employed this text to defend the full deity of the Spirit, Calvin believes that Jesus simply wished to underscore the “spiritual” nature of his Father. Calvin stresses this idea with strong, perhaps exaggerated, language: “God is so far from being like us, that those things which please us most are the objects of his loathing and abhorrence.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn44",
      "id": "fn44"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("First Corinthians 14")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("In order to get a sense of Calvin’s reading of 1 Corinthians 14, it might be helpful to summarize Paul’s train of thought in 14:6–19."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn45",
      "id": "fn45"
    }
  }, [_vm._v("45")])]), _vm._v(" Revolving around a discussion of the relative place of tongues and prophecy in public worship, Paul uses musical instruments as a metaphor to explain human speech. If a flute or bugle is blown indiscriminately, he reasons, only a jumble of sounds will result (vv. 7–8). Conversely, if a person were to blow distinct sounds through a bugle, then one might prepare oneself for battle. All human languages, Paul argues analogously, retain a meaning, "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("but only for the one who recognizes the intent of the language. Otherwise, it will be like speaking to a foreigner or “barbarian” (v. 11). In the context of corporate worship the aim should be to “abound for the edification of the church,” which can occur only if the speech is “intelligible” (v. 12; cf. vv. 3–4, 6)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn46",
      "id": "fn46"
    }
  }, [_vm._v("46")]), _vm._v(" Tongues benefit the “spirit” ("), _c('i', [_vm._v("pneuma")]), _vm._v(") but not the “mind” ("), _c('i', [_vm._v("nous")]), _vm._v(", v. 14; cf. vv. 2, 4). “Therefore,” Paul writes, “let one who speaks in a tongue pray that he may interpret” (v. 13) so that edification may ensue for the church."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn47",
      "id": "fn47"
    }
  }, [_vm._v("47")])]), _vm._v(" Paul’s resolution is noteworthy: “I will pray with the spirit and I will pray with the mind also; I will sing ["), _c('i', [_vm._v("psalō")]), _vm._v("] with the spirit and I will sing ["), _c('i', [_vm._v("psalō")]), _vm._v("] with the mind also” (v. 15; cf. vv. 27–33, 39!). If, Paul adds, prayer occurs only with the spirit (i.e., in tongues), others will neither understand what is being prayed nor be edified (vv. 16–17); and then he ends his admonition with a hyperbolic declaration: “In the church I desire to speak five words with my mind so that I may instruct others also, rather than ten thousand words in a tongue” (v. 19)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn48",
      "id": "fn48"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Whereas Paul employs musical instruments as a metaphor, Calvin interprets Paul to mean them literally. And whereas Paul enjoins both prophecy and tongues (appropriately exercised), Calvin concludes that only prophecy, as a work of the mind, will result in an edifying experience for the assembly."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn49",
      "id": "fn49"
    }
  }, [_vm._v("49")])]), _vm._v(" “How foolish then it is and preposterous in a man, to utter in an assembly a voice of which the hearer understands nothing.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn50",
      "id": "fn50"
    }
  }, [_vm._v("50")])]), _vm._v(" And again, paraphrasing, “What can be plainer than this prohibition—‘let not prayers or thanksgivings be offered up in public, except in the vernacular tongue’?”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn51",
      "id": "fn51"
    }
  }, [_vm._v("51")])]), _vm._v(" As Calvin sees it, Paul argues that all public prayer must involve the mind: “Let us take notice, that Paul reckons it a great fault if the mind is not occupied in prayer.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn52",
      "id": "fn52"
    }
  }, [_vm._v("52")])]), _vm._v(" With regard to 14:15, Calvin notes that Paul teaches that “it is lawful, indeed, to pray with the spirit, provided "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("the mind be at the same time employed”;"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn53",
      "id": "fn53"
    }
  }, [_vm._v("53")]), _vm._v(" or put negatively, “the prayers of every one of us will be vain and unfruitful, if the understanding does not go along with the voice.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn54",
      "id": "fn54"
    }
  }, [_vm._v("54")])]), _vm._v(" He grants that “spirit” prayer has a place in the assembly, so long as the mind is also at work, but he appears here to conflate in a single experience what Paul envisions as separate experiences for the believer.")]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("A Cast of Mind")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("As a way toward clarity, I propose that it might be useful to speak in terms of a cast of mind. Whereas any given line of argument in Calvin’s writings lands us in disparate hermeneutical and dogmatic territory, certain patterns of reasoning remain consistent. I suggest at least three distinctive casts of mind: biblical, theological, and pastoral.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Biblical Cast of Mind")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("Calvin’s biblical approach is not one we might initially suspect. While he argues repeatedly that the church’s worship should accord with God’s explicit commands in Scripture, this is not the approach that he adopts toward musical instruments. Calvin "), _c('i', [_vm._v("does not")]), _vm._v(" say: God fails to command or commend instruments in the New Testament (as God does with song), therefore we ought to avoid them."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn55",
      "id": "fn55"
    }
  }, [_vm._v("55")])]), _vm._v(" Calvin "), _c('i', [_vm._v("does")]), _vm._v(" say: instruments belong to the era of figures and shadows, therefore we ought to leave them there. To bring them into public worship is to “ape” Israel’s worship, to “bury Christ,” and to “pervert” true Christian worship. Where he does appeal to command language in his Psalms commentaries is in reference to two decisive texts: John 4 and 1 Corinthians 14. God commands worship that is “in spirit and truth” and “articulate.”")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Calvin’s biblical logic, then, might be summarized this way: just as we have received the “clear light of the gospel,” so we must worship God in substantially inward, formally simple, and rationally intelligible fashion."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn56",
      "id": "fn56"
    }
  }, [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Theological Cast of Mind")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Calvin’s theological cast of mind involves a conflict of interest: between an enthusiastic doctrine of creation (largely outside of the context of public worship) and a “creaturely pessimism” (largely within the context of public worship)."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn57",
      "id": "fn57"
    }
  }, [_vm._v("57")]), _vm._v(" As Begbie points out, Calvin’s affirmation of creation as the theater of God’s glory might lead us to believe that musical instruments will be given their own distinctive contribution to human flourishing, grounded, that is, in a theology of creation rather than in a theological anthropology."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn58",
      "id": "fn58"
    }
  }, [_vm._v("58")])]), _vm._v(" But in Calvin’s argument it does not. While, for example, the Lord was “pleased to use such visible figures” (like the embodied practice of baptism),"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn59",
      "id": "fn59"
    }
  }, [_vm._v("59")])]), _vm._v(" we also find, in Calvin, that God “did not delight in these external things” (like the ornaments of Israel’s worship) but rather made them available “because of the infirmity of the times.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn60",
      "id": "fn60"
    }
  }, [_vm._v("60")])]), _vm._v(" While Calvin affirms that the glory of God rightly shines “in the several parts of our bodies,” he concedes that material ceremonies are permitted because our “weakness renders these necessary.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn61",
      "id": "fn61"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In Calvin’s theological logic, then, the “spiritual” nature of God, the “gravity” of heavenly worship, and the “crude and weak” capacity of humans, prone to misuse material reality, require an internally oriented, sober public worship. To include musical instruments in worship is “to make a confused mixture which confounds heaven and earth.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn62",
      "id": "fn62"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("Pastoral Cast of Mind")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("With respect to Calvin’s pastoral cast of mind, the following points are key. Calvin accepts the patristic line of thinking almost exclusively, except in his encouragement of instruments “at home” and “in the fields.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn63",
      "id": "fn63"
    }
  }, [_vm._v("63")])]), _vm._v(" Following the Antiochene rather than the Alexandrian exegesis of music, "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Calvin echoes the patristic concern for “logocentricity,” “togetherness” in worship, the moral power of music, and the close link between “spiritual” and “internal.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn64",
      "id": "fn64"
    }
  }, [_vm._v("64")]), _vm._v(" With respect to the humanist scholars of the day, Calvin reiterates their concern for simplicity, decorum, intelligibility, clarity, and a respectful deference to the “ancients.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn65",
      "id": "fn65"
    }
  }, [_vm._v("65")])]), _vm._v(" While Erasmus, for instance, allowed space for musical instrumentation in the Mass, he strongly warned against semiprofane ceremonies, the indulgent behavior of choristers, “lascivious” melodies, and song that was disconnected from the text."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn66",
      "id": "fn66"
    }
  }, [_vm._v("66")])]), _vm._v(" As a pastor, Calvin had good reason to worry over the liturgical conditions for ready abuse (per Rome) and over the human proclivity to turn material objects to idolatrous and superstitious use (per the Genevan Christians under his care)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn67",
      "id": "fn67"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("According to Calvin’s pastoral logic, then, it is better to remove the sources of temptation. The human tendency to abuse material aids to worship is “a contagion disease of sorts,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn68",
      "id": "fn68"
    }
  }, [_vm._v("68")])]), _vm._v(" and only an “economical” ceremonial apparatus is able to preserve the believer in the right worship of God."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn69",
      "id": "fn69"
    }
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Critical Questions")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("What kind of initial critical response might we offer in light of the above?")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("A Comment on Calvin’s Exegesis")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("With respect to Calvin’s exegesis, we might begin by questioning his reading of the principal texts. In Calvin’s writings, the notion of “spiritual” "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("is expressed in two ways: on the one hand, to designate the inward encounter with God and, on the other, to indicate a minimal ceremonial apparatus. For Calvin, at issue in John 4 is the invisible essence of God, which confronts the human spirit by way of heart and mind."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn70",
      "id": "fn70"
    }
  }, [_vm._v("70")]), _vm._v(" Might a careful rereading of the Johannine narrative, however, lead us to a different conclusion? If the phrase “God is Spirit” describes not the nature of God but rather the person of the Spirit, and if “Spirit and Truth” identifies something about God instead of humanity, the narrative would press us to read this passage in a rather more Trinitarian light than in an essentialist one. When we consider certain trajectories in John, we might also discover a healthy estimation of the material dimension of creation—from the enfleshed Logos to the new-creation subtext that runs throughout. From these emphases, John’s narrative invites us to infer a far more integral relationship between the “spiritual” and the “material” dimensions of corporate worship than perhaps Calvin himself imagined. We take up this matter in chapter 8.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("According to Calvin, the so-called simplicity of Christ requires a simple liturgical ceremony."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn71",
      "id": "fn71"
    }
  }, [_vm._v("71")])]), _vm._v(" Heirs of the Frenchman have questioned this rationale. Hughes Old, for example, writes, “The Scriptures themselves do not even suggest that [the musical accompaniment in worship] should be restrained, simple or unadorned. If the early Reformed Church was of that opinion, it was probably more because of the warnings of the Church Fathers than because of the directions of either Old or New Testament.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn72",
      "id": "fn72"
    }
  }, [_vm._v("72")])]), _vm._v(" Philip Butin argues that an “unnecessarily spare” worship in Reformed churches betrays a defective Trinitarian orientation,"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn73",
      "id": "fn73"
    }
  }, [_vm._v("73")])]), _vm._v(" while Auksi, more forcefully, contends that Calvin’s liturgical aesthetic drives “towards ultimate simplicity in means and ends, towards an intense spiritualism independent of sensory stimulation,” and away from “the profound actuality of a tangible communion.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn74",
      "id": "fn74"
    }
  }, [_vm._v("74")])]), _vm._v(" Chapter 9 addresses these concerns in detail.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("With respect to Calvin’s reading of 1 Corinthians 14, we point out a possible discrepancy. If Calvin has read Paul rightly, that “spirit” prayer can occur in corporate worship only if the mind is involved, the analogy to musical instruments still breaks down. Calvin affirms that prayer involving the “spirit” (i.e., inarticulate prayer), even in its subordinate status to prayer involving the mind (i.e., articulate prayer), belongs in the church’s liturgy."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn75",
      "id": "fn75"
    }
  }, [_vm._v("75")]), _vm._v(" But for reasons that cannot be explained from his Corinthians exegesis alone, his argument in the Psalms commentaries cannot envision a way that musical instruments—as a form of “spirit” and therefore inarticulate prayer—could also be included in corporate worship. On the reasoning of his Corinthian exegesis, one might argue for instruments so long as they were exclusively used as accompaniment and therefore in a subordinate role to congregational song. If St. Paul has not proscribed the use of tongues-speaking in public worship (a big “if,” I grant), then surely there is a place for musical instruments as an analogous means of inarticulate though still intelligible worship. What Calvin, unlike Bucer, could not countenance was a place for instrumental music alone, where believers did not lend their voices with “understanding” in the praise of God."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn76",
      "id": "fn76"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("A Comment on Calvin’s Theology of Materiality")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("With Calvin’s theological reading of materiality, we encounter a rhetoric that remains consistently wary of the physical media of worship. In his exegesis of Psalm 9:11, Calvin remarks: “The design of God from the commencement in the appointment of the sacraments, and all the outward exercises of religion, was to consult the infirmity and weak capacity of his people. Accordingly, even at the present day, the true and proper use of them is, to assist us in seeking God spiritually in his heavenly glory, and not to occupy our minds with the things of this world, or keep them fixed in the vanities of the flesh.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn77",
      "id": "fn77"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("As God is “spiritual,” Calvin writes in the "), _c('i', [_vm._v("Institutes")]), _vm._v(", so “only spiritual worship delights him.”"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn78",
      "id": "fn78"
    }
  }, [_vm._v("78")]), _vm._v(" God “descends to us,” he adds in his sermons on 2 Samuel, “not to stupefy or bind our senses in these low and feeble things . . . but rather that we should be lifted on high to adore him spiritually, and that we should thereby rise above the world by our faith.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn79",
      "id": "fn79"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Calvin repeatedly warns against the abuse of external aids to worship, and rightly so."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn80",
      "id": "fn80"
    }
  }, [_vm._v("80")])]), _vm._v(" False attachments to them jeopardize faithful worship. Yet one is frequently left with the impression that Calvin, much like Zwingli, remains suspicious of external aids "), _c('i', [_vm._v("as such")]), _vm._v(". His ambiguous use of “ascent” language to describe the purpose of material aids often gives the impression that they are unfortunate requirements."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn81",
      "id": "fn81"
    }
  }, [_vm._v("81")])]), _vm._v(" The “prison house of our flesh” leads us to crave external aids, while “the idle splendor of the flesh” accounts for Rome’s attraction to a “mass of ceremonies.”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn82",
      "id": "fn82"
    }
  }, [_vm._v("82")])]), _vm._v(" When combined with a sharp turn toward “interiority,” a curious fascination with the incorporeal nature of angels, and the frequent emphasis on the “crude,” “feeble,” “cold,” “lazy,” “vain,” and “rude” nature of humanity, one wonders whether the “weakness” that concerns Calvin pertains to "), _c('i', [_vm._v("sinful")]), _vm._v(" physical reality or to "), _c('i', [_vm._v("creaturely")]), _vm._v(" physical reality."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn83",
      "id": "fn83"
    }
  }, [_vm._v("83")])]), _vm._v(" One wonders why the work of the Spirit to make us partakers of Christ’s “flesh” carries so little theological weight in Calvin’s formulation of public worship. We address these issues in chapters 2–7.")]), _vm._v(" "), _c('p', {
    staticClass: "H2"
  }, [_vm._v("A Comment on Calvin’s Historical Context")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("With respect to Calvin’s historical context, it is important that we not presume simple lines of causality. The liturgical practices of a Catholic Geneva, a generation prior to Calvin’s arrival, cannot be said to have "), _c('i', [_vm._v("caused")]), _vm._v(" Calvin to act one way or another. Calvin is his own man, just as he is a man "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("of his own times. This is perhaps to state the obvious, but it still bears mentioning. Why he parts ways with Luther, Bucer, or Zwingli in his vision of liturgical music, then, cannot be accounted for on exegetical terms alone. Where Luther extolled the psychological tonic of music, Calvin, like Augustine, influenced by Plato, fretted over its ability to distort the heart, despite his belief that Israel had benefited from music’s affective powers. Where Luther praised both the music of nature ("), _c('i', [_vm._v("musica naturalis")]), _vm._v(") and instrumental music ("), _c('i', [_vm._v("musica artificialis")]), _vm._v("), Calvin could make room only for the human voice ("), _c('i', [_vm._v("musica humana")]), _vm._v(") in public worship. Where, in this vein, Luther engages the medieval cosmological outlook on music, Calvin remains silent on it."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn84",
      "id": "fn84"
    }
  }, [_vm._v("84")]), _vm._v(" With Zwingli, Calvin stressed the importance of rational understanding in the people’s praise. Unlike the Zurich pastor, however, who insisted that St. Paul’s meaning in Colossians argued for a voiceless singing of the heart, Calvin believed that the mind, heart, and voice "), _c('i', [_vm._v("could")]), _vm._v(" sing to God in one accord."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn85",
      "id": "fn85"
    }
  }, [_vm._v("85")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Whereas Bucer’s typological reading of Israel’s worship made room for instruments in Christian worship, Calvin’s reading excluded them altogether."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn86",
      "id": "fn86"
    }
  }, [_vm._v("86")])]), _vm._v(" Where Bucer, appealing to the principle of simplicity, saw how they might provoke the believer to a “more fulsome praise of God,” Calvin, likewise appealing to the need for simplicity, saw them as real distractions."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn87",
      "id": "fn87"
    }
  }, [_vm._v("87")])]), _vm._v(" His commendation of “restrained” singing appears to be at odds, we might add, to the kind of singing that the Psalter itself commends—with its exhortations to shout, burst, revel, clap, and cry unto the Lord. And the fact that angels in heaven repeatedly blow trumpets fails to factor in Calvin’s understanding of the eschatological dimension of worship."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn88",
      "id": "fn88"
    }
  }, [_vm._v("88")])]), _vm._v(" This view is in contrast, on the one hand, to Bucer, who believed that instrumental praise anticipated “the blessed festivities of the life to come,”"), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn89",
      "id": "fn89"
    }
  }, [_vm._v("89")])]), _vm._v(" and, on the other, "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("to Luther, who believed that the music of heaven directly influenced the music of the church."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn90",
      "id": "fn90"
    }
  }, [_vm._v("90")]), _vm._v(" Finally, while experience compels him to include song as a stimulant to praise and a medicine for cold affections, it is curious that Calvin also appeals to experience to exclude musical instruments in the public assembly."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn91",
      "id": "fn91"
    }
  }, [_vm._v("91")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("Calvin’s concerns for right worship are shared not only by fellow Reformers but also, in various ways, by Catholic Europe."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn92",
      "id": "fn92"
    }
  }, [_vm._v("92")])]), _vm._v(" From Erasmus of Rotterdam to Martin Navarrus, a Spanish professor of canon law, a pattern of worries emerges—over melodies that drew attention away from the Mass and over musical practices that caused the assembly to engage in activities such as talking, joking, laughing, and carrying on business in neglect of faithful worship. The changes decreed by the Council of Trent represent an attempt, in its own way, to address what were perceived as problematic practices in liturgical music. From a committee of deputies who met on September 10, 1562, a series of changes were recommended:")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("The whole plan of singing in musical modes should be constituted not to give empty pleasure to the ear, but in such a way that the words may be clearly understood by all, and thus the hearts of listeners be drawn to the desire of heavenly harmonies, in the contemplation of the joys of the blessed. . . . They shall also banish from church all music that contains, whether in the singing or in the organ playing, things that are lascivious or impure; as also all secular actions; vain and therefore profane conversations, all walking about, noise, and clamour, that so the house of God may be seen to be, and may be called, truly a house of prayer."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn93",
      "id": "fn93"
    }
  }, [_vm._v("93")])])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("The diversity of liturgical music throughout Catholic Europe notwithstanding,"), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/#rfn94",
      "id": "fn94"
    }
  }, [_vm._v("94")]), _vm._v(" the Mass, prior to Trent, would have been linguistically unintelligible to the average layperson (because in Latin), vocally expressive (on account of polyphonic and choral practices), extrabiblical (in its use of secular materials), and musically difficult (in view of the use of professionals, such as court musicians and cathedral choirs)."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn95",
      "id": "fn95"
    }
  }, [_vm._v("95")])]), _vm._v(" Calvin’s social location, under this light, perhaps accounts to some degree for the intensity of his concern for the aesthetic dimension of public worship. A serious pastoral, and even psychological, matter was at stake. Long-standing habits required, one might concede, a forceful word with a resolute conviction."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn96",
      "id": "fn96"
    }
  }, [_vm._v("96")])])]), _vm._v(" "), _c('p', {
    staticClass: "H1"
  }, [_vm._v("Conclusion")]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush1"
  }, [_vm._v("While Calvin’s contemporaries invariably appealed to common biblical texts in their proposals for the church’s worship, the actual musical shape of that worship varied significantly from case to case, hinging, as it did, on a range of theological priorities, exegetical habits, and pastoral circumstances. Disagreements existed among them over what constituted a “childish” practice of Israel’s worship and what could be fittingly translated into Christian worship. At stake for many of them was the manner in which materiality could mediate the presence of God and the way in which the arts might serve the purposes of “acceptable” worship. As this chapter has attempted to show, Calvin’s argument against musical instruments cannot be attributed solely to his appeal to the notion of “figures and shadows”; the issues are far more complicated and interesting. "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("Equally important, as he understood it, was the need for the church’s worship to be “spiritual,” “simple,” and “articulate.” A common feature in all these emphases was a sense that the "), _c('i', [_vm._v("material")]), _vm._v(" aspect of musical instruments was somehow hazardous to the church’s worship.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "line",
      "src": "images/line1.jpg"
    }
  })])]), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1"
    }
  }, [_vm._v("1")]), _vm._v(". John Calvin, “Foreword to the Genevan Psalter,” in "), _c('i', [_vm._v("John Calvin: Writings on Pastoral Piety")]), _vm._v(", ed. Elsie A. McKee (New York: Paulist Press, 2001), 95 (hereafter "), _c('i', [_vm._v("Pastoral Piety")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn2"
    }
  }, [_vm._v("2")]), _vm._v(". John Calvin, “Articles concerning the Organization of the Church and of Worship at Geneva Proposed by the Ministers at the Council, January 16, 1537,” in "), _c('i', [_vm._v("The Library of Christian Classics")]), _vm._v(", vol. 22: "), _c('i', [_vm._v("Calvin: Theological Treatises,")]), _vm._v(" trans. J. K. S. Reid (Philadelphia: Westminster, 1954), 53 (hereafter “Articles”).")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn3"
    }
  }, [_vm._v("3")]), _vm._v(". Paul S. Jones, “Calvin and Music,” in "), _c('i', [_vm._v("Calvin and Culture")]), _vm._v(": "), _c('i', [_vm._v("Exploring a Worldview")]), _vm._v(", ed. David W. Hall and Marvin Padgett (Phillipsburg, NJ: P&R Publishing, 2010), 235.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn4"
    }
  }, [_vm._v("4")]), _vm._v(". Horton Davies, "), _c('i', [_vm._v("Worship and Theology in England")]), _vm._v(", vol. 1: "), _c('i', [_vm._v("From Andrewes to Baxter and Fox, 1603–1690")]), _vm._v(" (Princeton: Princeton University Press, 1975), 270–72; see also James H. Nichols, "), _c('i', [_vm._v("Corporate Worship in the Reformed Tradition")]), _vm._v(" (Philadelphia: Westminster, 1968), 38–40.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn5"
    }
  }, [_vm._v("5")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 33:2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn6"
    }
  }, [_vm._v("6")]), _vm._v(". Garside, “The Origins of Calvin’s Theology of Music: 1536–1543,” "), _c('i', [_vm._v("Transactions of the American Philosophical Society")]), _vm._v(" 4 (1969): 1–36.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn7"
    }
  }, [_vm._v("7")]), _vm._v(". H. P. Clive, “The Calvinist Attitude to Music, and Its Literary Aspects and Sources,” "), _c('i', [_vm._v("Bibliothèque d’Humanisme et Renaissance")]), _vm._v(" 19.1 (1957): 80–102.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn8"
    }
  }, [_vm._v("8")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Pss. 33:2; 57:8.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn9"
    }
  }, [_vm._v("9")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 92:3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn10"
    }
  }, [_vm._v("10")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 98:5–6.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn11"
    }
  }, [_vm._v("11")]), _vm._v(". See his comments in "), _c('i', [_vm._v("Sermons on 2 Samuel: Chapters 1–13")]), _vm._v(", trans. Douglas Kelly (Carlisle, PN: Banner of Truth Trust, 1992), 409.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn12"
    }
  }, [_vm._v("12")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 150:3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn13"
    }
  }, [_vm._v("13")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 149:3. Calvin makes a similar argument with respect to Miriam and the women of Exodus 15:20 and to David’s dancing in 2 Samuel 6:14. See Jon Balserak, "), _c('i', [_vm._v("Divinity Compromised: A Study of Divine Accommodation in the Thought of John Calvin")]), _vm._v(" (Dordrecht: Springer, 2006), 78–79.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn14"
    }
  }, [_vm._v("14")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 71:22.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn15"
    }
  }, [_vm._v("15")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 150:3–5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn16"
    }
  }, [_vm._v("16")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 71:22.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn17"
    }
  }, [_vm._v("17")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 98:5.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn18"
    }
  }, [_vm._v("18")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 81:2–3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn19"
    }
  }, [_vm._v("19")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 92:3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn20"
    }
  }, [_vm._v("20")]), _vm._v(". "), _c('i', [_vm._v("Sermons on 2 Samuel")]), _vm._v(", 234–39. Cf. "), _c('i', [_vm._v("Comm.")]), _vm._v(" Col. 3:16.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn21"
    }
  }, [_vm._v("21")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 92:3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn22"
    }
  }, [_vm._v("22")]), _vm._v(". "), _c('i', [_vm._v("Sermons on 2 Samuel")]), _vm._v(", 412; see also 236, 310.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn23"
    }
  }, [_vm._v("23")]), _vm._v(". Herman J. Selderhuis, "), _c('i', [_vm._v("Calvin’s Theology of the Psalms")]), _vm._v(" (Grand Rapids: Baker Academic, 2007), 209. Echoes of Augustine can be heard here.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn24"
    }
  }, [_vm._v("24")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 33:2. In "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 93:2 Calvin adds that, unlike humans, God does not take delight “in mere melody of sounds.” Cf. Jeremy Begbie, “Music, Word, and Theology Today: Learning from John Calvin,” in "), _c('i', [_vm._v("Theology in Dialogue: The Impact of the Arts")]), _vm._v(", "), _c('i', [_vm._v("Humanities, and Science on Contemporary Religious Thought; Essays in Honor of John W. de Gruchy")]), _vm._v(", ed. Lyn Holness and Ralf Wustenberg (Grand Rapids: Eerdmans, 2002), 24–27.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn25"
    }
  }, [_vm._v("25")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 92:3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn26"
    }
  }, [_vm._v("26")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 33:2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn27"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn27"
    }
  }, [_vm._v("27")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 81:2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn28"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn28"
    }
  }, [_vm._v("28")]), _vm._v(". See Calvin’s thoughts in "), _c('i', [_vm._v("Comm.")]), _vm._v(" 1 Sam. 18; "), _c('i', [_vm._v("Comm.")]), _vm._v(" 2 Cor. 4:16; "), _c('i', [_vm._v("Comm.")]), _vm._v(" 1 Tim. 4; and “Confession of Faith,” 152, 159.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn29"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn29"
    }
  }, [_vm._v("29")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 92:3.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn30"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn30"
    }
  }, [_vm._v("30")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 33:2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn31"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn31"
    }
  }, [_vm._v("31")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 71:22.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn32"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn32"
    }
  }, [_vm._v("32")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 33:2.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn33"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn33"
    }
  }, [_vm._v("33")]), _vm._v(". On this point, see Jeffrey T. VanderWilt, “John Calvin’s Theology of Liturgical Song,” "), _c('i', [_vm._v("Christian Scholar’s Review")]), _vm._v(" 25.1 (1995): 63–82.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn34"
    }
  }, [_vm._v("34")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Col. 2:17.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn35"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn35"
    }
  }, [_vm._v("35")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" John 4:23. Cf. Eire, "), _c('i', [_vm._v("War against the Idols")]), _vm._v(", 197–212.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn36"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn36"
    }
  }, [_vm._v("36")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" John 4:23.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn37"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn37"
    }
  }, [_vm._v("37")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" John 4:20.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn38"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn38"
    }
  }, [_vm._v("38")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" John 4:23.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn39"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn39"
    }
  }, [_vm._v("39")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" John 4:23.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn40"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn40"
    }
  }, [_vm._v("40")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Gal. 4:9.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn41"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn41"
    }
  }, [_vm._v("41")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" John 4:23.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn42"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn42"
    }
  }, [_vm._v("42")]), _vm._v(". Calvin elaborates on his meaning of “outward man” in his commentary on 2 Cor. 4:16–18.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn43"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn43"
    }
  }, [_vm._v("43")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" John 4:23.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn44"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn44"
    }
  }, [_vm._v("44")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" John 4:24.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn45"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn45"
    }
  }, [_vm._v("45")]), _vm._v(". Cf. Gordon Fee, "), _c('i', [_vm._v("God’s Empowering Presence: The Holy Spirit in the Letters of Paul")]), _vm._v(" (Peabody, MA: Hendrickson, 1994), 221–35.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn46"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn46"
    }
  }, [_vm._v("46")]), _vm._v(". Verse 26 reiterates this point, but in a way that might in fact undermine Calvin’s conclusion.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn47"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn47"
    }
  }, [_vm._v("47")]), _vm._v(". Fee, in "), _c('i', [_vm._v("God’s Empowering Presence")]), _vm._v(", 228, notes that the presumed conclusion to Paul’s point here would be that prophecy should prevail over tongues in worship, but, he writes, “prophecy is not Paul’s first concern, intelligibility is.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn48"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn48"
    }
  }, [_vm._v("48")]), _vm._v(". Fee, "), _c('i', [_vm._v("God’s Empowering Presence")]), _vm._v(", 261.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn49"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn49"
    }
  }, [_vm._v("49")]), _vm._v(". In "), _c('i', [_vm._v("Comm.")]), _vm._v(" 1 Cor. 14:14, Calvin stresses the inwardness of such worship: “As prayer is the spiritual worship of God, what is more at variance with the nature of it, than that it should proceed merely from the lips, and not from the inmost soul?”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn50"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn50"
    }
  }, [_vm._v("50")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" 1 Cor. 14:11. In Calvin’s mind the “papists” fail repeatedly on this account.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn51"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn51"
    }
  }, [_vm._v("51")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" 1 Cor. 14:16.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn52"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn52"
    }
  }, [_vm._v("52")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" 1 Cor. 14:14.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn53"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn53"
    }
  }, [_vm._v("53")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" 1 Cor. 14:15.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn54"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn54"
    }
  }, [_vm._v("54")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" 1 Cor. 14:16.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn55"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn55"
    }
  }, [_vm._v("55")]), _vm._v(". Cf. Eph. 5:19; Col. 3:16; James 5:13; Heb. 2:12; 1 Cor. 14:15.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn56"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn56"
    }
  }, [_vm._v("56")]), _vm._v(". Acts 2 might also be seen to factor significantly in Calvin’s thinking here.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn57"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn57"
    }
  }, [_vm._v("57")]), _vm._v(". Canlis employs this phrase in "), _c('i', [_vm._v("Calvin’s Ladder")]), _vm._v(", 243.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn58"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn58"
    }
  }, [_vm._v("58")]), _vm._v(". Jeremy S. Begbie, "), _c('i', [_vm._v("Music, Modernity, and God")]), _vm._v(" (Oxford: Oxford University Press, 2013), 34.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn59"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn59"
    }
  }, [_vm._v("59")]), _vm._v(". 4.15.14.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn60"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn60"
    }
  }, [_vm._v("60")]), _vm._v(". "), _c('i', [_vm._v("Sermons on 2 Samuel")]), _vm._v(", 413.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn61"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn61"
    }
  }, [_vm._v("61")]), _vm._v(". 3.20.31.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn62"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn62"
    }
  }, [_vm._v("62")]), _vm._v(". "), _c('i', [_vm._v("Sermons on 2 Samuel")]), _vm._v(", 241.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn63"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn63"
    }
  }, [_vm._v("63")]), _vm._v(". Hughes Oliphant Old, "), _c('i', [_vm._v("The Patristic Roots of Reformed Worship")]), _vm._v(" (Zürich: Theologischer Verlag, 1975), 45.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn64"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn64"
    }
  }, [_vm._v("64")]), _vm._v(". Particularly helpful on this account is Everett Ferguson, “Toward a Patristic Theology of Music,” "), _c('i', [_vm._v("Studia Patristica")]), _vm._v(" 24 (1993): 266–83.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn65"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn65"
    }
  }, [_vm._v("65")]), _vm._v(". Hyun-Ah Kim, “Erasmus on Sacred Music,” "), _c('i', [_vm._v("Reformation and Renaissance Review")]), _vm._v(" 8.3 (2006): 277–300. See also Clement A. Miller, “Erasmus on Music,” "), _c('i', [_vm._v("Musical Quarterly")]), _vm._v(" 52.3 (1966): 332–49; Charles Garside Jr., “Calvin’s Preface to the Psalter: A Re-Appraisal,” "), _c('i', [_vm._v("Musical Quarterly")]), _vm._v(" 37.4 (1951): 566–77.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn66"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn66"
    }
  }, [_vm._v("66")]), _vm._v(". Kim, “Erasmus on Sacred Music,” 290–96.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn67"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn67"
    }
  }, [_vm._v("67")]), _vm._v(". See Clive, “The Calvinist Attitude to Music,” 94, 98.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn68"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn68"
    }
  }, [_vm._v("68")]), _vm._v(". Eire, "), _c('i', [_vm._v("War against the Idols")]), _vm._v(", 231–32.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn69"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn69"
    }
  }, [_vm._v("69")]), _vm._v(". John H. Leith, "), _c('i', [_vm._v("Introduction to the Reformed Tradition: A Way of Being the Christian Community")]), _vm._v(" (Atlanta: John Knox Press, 1977), 167, believes that “economical” is preferable to “austere” in describing Calvin’s liturgical sensibility.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn70"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn70"
    }
  }, [_vm._v("70")]), _vm._v(". In "), _c('i', [_vm._v("Sermons on 2 Samuel")]), _vm._v(", 232, 235, 311, Calvin states that God’s essence is “spiritual,” “invisible,” and “celestial.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn71"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn71"
    }
  }, [_vm._v("71")]), _vm._v(". On this account, Calvin argues for a certain translation of the phrase in 2 Corinthians 11:3 that is not widely followed by New Testament scholars, believing that the phrase modifies Christ rather than the believer.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn72"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn72"
    }
  }, [_vm._v("72")]), _vm._v(". Old, "), _c('i', [_vm._v("The Patristic Roots of Reformed Worship")]), _vm._v(", 268–69, esp. 269n1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn73"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn73"
    }
  }, [_vm._v("73")]), _vm._v(". Philip Butin, “Constructive Iconoclasm: Trinitarian Concern in Reformed Worship,” "), _c('i', [_vm._v("Studia Liturgica")]), _vm._v(" 19 (1989): 140.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn74"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn74"
    }
  }, [_vm._v("74")]), _vm._v(". Peter Auksi, “Simplicity and Silence: The Influence of Scripture on the Aesthetic Thought of the Major Reformers,” "), _c('i', [_vm._v("Journal of Religious History")]), _vm._v(" 10.4 (1979): 361, 363.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn75"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn75"
    }
  }, [_vm._v("75")]), _vm._v(". Calvin does, in fact, concede Paul’s argument (in 14:26–33) that tongues, while not as enthusiastically commended as prophecy, do have a place in the church’s worship.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn76"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn76"
    }
  }, [_vm._v("76")]), _vm._v(". R. Gerald Hobbs, “‘Quam Apposita Religioni Sit Musica’: Martin Bucer and Music in the Liturgy,” "), _c('i', [_vm._v("Reformation and Renaissance Review")]), _vm._v(" 6.2 (2004): 174. Bucer also conceded the use of Latin in the church’s liturgical song.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn77"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn77"
    }
  }, [_vm._v("77")]), _vm._v(". "), _c('i', [_vm._v("Comm.")]), _vm._v(" Ps. 9:11. Cf. Eire, "), _c('i', [_vm._v("War against the Idols")]), _vm._v(", 200–202; Canlis, "), _c('i', [_vm._v("Calvin’s Ladder")]), _vm._v(", 120–21. See also 4.19.15; 17.5, 10.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn78"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn78"
    }
  }, [_vm._v("78")]), _vm._v(". 2.7.1; cf. 1.13.1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn79"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn79"
    }
  }, [_vm._v("79")]), _vm._v(". "), _c('i', [_vm._v("Sermons on 2 Samuel")]), _vm._v(", 235–36. See also "), _c('i', [_vm._v("Comm.")]), _vm._v(" Exod. 25:8; Canlis, "), _c('i', [_vm._v("Calvin’s Ladder")]), _vm._v(", 169.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn80"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn80"
    }
  }, [_vm._v("80")]), _vm._v(". See esp. 2.10.8, 23 and 3.20.30.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn81"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn81"
    }
  }, [_vm._v("81")]), _vm._v(". On this account, see Witvliet’s excellent exposition in "), _c('i', [_vm._v("Worship Seeking Understanding")]), _vm._v(", 133–40.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn82"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn82"
    }
  }, [_vm._v("82")]), _vm._v(". See his comments on Psalms 24:7 and 28:2 and on John 4:23.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn83"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn83"
    }
  }, [_vm._v("83")]), _vm._v(". In "), _c('i', [_vm._v("Comm.")]), _vm._v(" Jer. 31:4, Calvin interprets mention of tambourines and dances as a reference to “holy joy” rather than actual musical instruments. Cf. Garside, “Origins,” 9; Elsie McKee, “Context, Contours, Contents,” "), _c('i', [_vm._v("Princeton Theological Seminary Bulletin")]), _vm._v(" 16 (1995): 167–68.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn84"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn84"
    }
  }, [_vm._v("84")]), _vm._v(". Cf. Begbie, "), _c('i', [_vm._v("Music, Modernity, and God")]), _vm._v(", 27ff. Luther also grounds his musical propositions in a doctrine of creation, which is something Calvin fails to do. See "), _c('i', [_vm._v("Luther’s Works")]), _vm._v(", vol. 53: "), _c('i', [_vm._v("Liturgy and Hymns")]), _vm._v(" (Philadelphia: Fortress, 1965), 321–24.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn85"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn85"
    }
  }, [_vm._v("85")]), _vm._v(". Charles Garside Jr., "), _c('i', [_vm._v("Zwingli and the Arts")]), _vm._v(" (New Haven: Yale University Press, 1966), 37, 45, 53.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn86"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn86"
    }
  }, [_vm._v("86")]), _vm._v(". Hobbs, “Quam Apposita Religioni Sit Musica,” 165, 169, 175–76. Key textual loci for Bucer include Col. 3, Eph. 5, Deut. 6, and the narratives of King David and the prophet Elisha. Bucer also made space for hymns, not just psalms, so long as they were “in conformity with Scripture.”")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn87"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn87"
    }
  }, [_vm._v("87")]), _vm._v(". Hobbs, “Quam Apposita Religioni Sit Musica,” 170, 176–77.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn88"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn88"
    }
  }, [_vm._v("88")]), _vm._v(". Cf. "), _c('i', [_vm._v("Pastoral Piety")]), _vm._v(", 94–97. See also "), _c('i', [_vm._v("Comm.")]), _vm._v(" 1 Cor. 15:52; "), _c('i', [_vm._v("Comm.")]), _vm._v(" 1 Thess. 4:16; "), _c('i', [_vm._v("Comm.")]), _vm._v(" Matt. 24:31.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn89"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn89"
    }
  }, [_vm._v("89")]), _vm._v(". Hobbs, “Quam Apposita Religioni Sit Musica,” 170.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn90"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn90"
    }
  }, [_vm._v("90")]), _vm._v(". Andreas Loewe, “‘Musica est Optimum’: Martin Luther’s Theory of Music,” "), _c('a', {
    attrs: {
      "href": "http://mcd.academia.edu/loewe/Papers/1074845/Musica_est_optimum_Martin_Luthers_Theory_of_Music",
      "target": "_blank"
    }
  }, [_vm._v("http://mcd.academia.edu/loewe/Papers/1074845/Musica_est_optimum_Martin_Luthers_Theory_of_Music")]), _vm._v(", 33–38.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn91"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn91"
    }
  }, [_vm._v("91")]), _vm._v(". See 3.20.31; "), _c('i', [_vm._v("Sermons on Job")]), _vm._v(" 21:2, trans. Rob McGregor (Edinburgh: Banner of Truth Trust, 1993), vol. 1.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn92"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn92"
    }
  }, [_vm._v("92")]), _vm._v(". For an introduction to liturgical music in Catholic churches of sixteenth-century Europe, see Gustave Reese, "), _c('i', [_vm._v("Music in the Renaissance")]), _vm._v(" (New York: Norton, 1959), 358–62, 448; Christopher Boyd Brown, "), _c('i', [_vm._v("Singing the Gospel: Lutheran Hymns and the Success of the Reformation")]), _vm._v(" (Cambridge, MA: Harvard University Press, 2005); Joseph Herl, "), _c('i', [_vm._v("Worship Wars in Early Lutheranism: Choir, Congregation, and Three Centuries of Conflict")]), _vm._v(" (Oxford: Oxford University Press, 2004), 25–26; and Friedrich Blume, "), _c('i', [_vm._v("Protestant Church Music: A History")]), _vm._v(" (New York: Norton, 1974), 127–85.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn93"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn93"
    }
  }, [_vm._v("93")]), _vm._v(". As cited in David W. Music, "), _c('i', [_vm._v("Instruments in Church: A Collection of Source Documents")]), _vm._v(" (Lanham, MD: Scarecrow Press, 1998), 68–69.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn94"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn94"
    }
  }, [_vm._v("94")]), _vm._v(". On this issue, see Korrick’s excellent treatment in “Instrumental Music in the Early Sixteenth-Century Mass: New Evidence,” esp. 360–63; Francis Higman, “Music,” in "), _c('i', [_vm._v("The Reformation World")]), _vm._v(", ed. Andrew Pettegree (London: Routledge, 2000), 491–504; Robert M. Kingdon, “The Genevan Revolution in Public Worship,” "), _c('i', [_vm._v("Princeton Seminary Bulletin")]), _vm._v(" 20.3 (1999): 264–80; and Jeffrey Dean, “Listening to Sacred Polyphony, c. 1500,” "), _c('i', [_vm._v("Early Music")]), _vm._v(" 25.4 (1997): 611–36.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn95"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn95"
    }
  }, [_vm._v("95")]), _vm._v(". Especially helpful on these points is Lewis Lockwood, “Music and Religion in the High Renaissance and the Reformation,” in "), _c('i', [_vm._v("The Pursuit of Holiness in Late Medieval and Renaissance Religion")]), _vm._v(", ed. Charles Trinkaus, with Heiko A. Oberman (Leiden: Brill, 1974), 500–502.")]), _vm._v(" "), _c('p', {
    staticClass: "foot",
    attrs: {
      "id": "rfn96"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/#fn96"
    }
  }, [_vm._v("96")]), _vm._v(". Elsie Anne McKee, “Reformed Worship in the Sixteenth Century,” in "), _c('i', [_vm._v("Christian Worship in Reformed Churches Past and Present")]), _vm._v(", ed. Lukas Vischer (Grand Rapids: Eerdmans, 2003), offers a valuable pastoral perspective on Calvin’s context in Geneva.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aa5eff4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter001.vue
// module id = 84
// module chunks = 0